import React from "react";
import ChatLoadingContextProvider from "../chat/ChatLoadingContextProvider";
import VoicePlayerContextProvider from "../chat/voicePlayer.context";
import SupportChat from "./SupportChat";

const supportchatPage = () => {
  return (
    <VoicePlayerContextProvider>
      <ChatLoadingContextProvider>
        <SupportChat />
      </ChatLoadingContextProvider>
    </VoicePlayerContextProvider>
  );
};

export default supportchatPage;
